export const blockIconsCommunicationHourglassBottomNew = (
	<span className='material-symbols-outlined'>hourglass_bottom</span>
);
